"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkPreviewSettings = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var inversify_react_1 = require("inversify-react");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var LinkPreviewImageButton_1 = require("./LinkPreviewImageButton");
var LinkPreviewCard_1 = require("../../Common/LinkPreview/LinkPreviewCard");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var GetPageImages_1 = require("./GetPageImages");
var UpsellerService_1 = __importDefault(require("Common/Upseller/UpsellerService"));
var AssetLibraryOverlay_1 = require("Common/AssetLibrary/AssetLibraryOverlay");
var BASE_CLASS_NAME = "link-preview-settings";
var LinkPreviewSettings = (function (_super) {
    __extends(LinkPreviewSettings, _super);
    function LinkPreviewSettings() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.allImageUrls = [];
        _this.planRequiredForDefaultsOverride = null;
        _this.isAdminUser = _this.rolesService.isAdmin(_this.user);
        _this.getPlanNameRequiredForDefaultsOverride = function () { return __awaiter(_this, void 0, void 0, function () {
            var featurePlan_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.hasAccessToDefaultsOverride && this.isAdminUser)) return [3, 2];
                        return [4, this.upsellerService.getPlanNameForFeature("linkPreviewDefaultsOverride")];
                    case 1:
                        featurePlan_1 = _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.planRequiredForDefaultsOverride = featurePlan_1;
                        });
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        }); };
        _this.getImagesForPreviewButtons = function () { return __awaiter(_this, void 0, void 0, function () {
            var images;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, GetPageImages_1.grabAllImageUrls)(this.props.projectId, 5, this.apiBaseUrl)];
                    case 1:
                        images = _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.allImageUrls = __spreadArray([_this.props.linkPreviewSettingsStore.previewDefaultImageUrl], __read(images), false);
                        });
                        return [2];
                }
            });
        }); };
        _this.handleLinkPreviewImageChange = function (imageUrl) {
            if (_this.props.canEdit) {
                _this.props.linkPreviewSettingsStore.handleLinkPreviewImageChange(imageUrl);
            }
        };
        _this.openLibraryClick = function () {
            _this.assetLibraryOverlay.launchBasicOverlay(function (mediaSource, data) {
                _this.handleLinkPreviewImageChange(data.url);
            });
        };
        return _this;
    }
    LinkPreviewSettings.prototype.componentDidMount = function () {
        this.getPlanNameRequiredForDefaultsOverride();
        this.getImagesForPreviewButtons();
    };
    Object.defineProperty(LinkPreviewSettings.prototype, "hasAccessToDefaultsOverride", {
        get: function () {
            return this.props.usingFeature(FeatureFlag_1.default.LinkPreviewDefaultsOverride);
        },
        enumerable: false,
        configurable: true
    });
    LinkPreviewSettings.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, defaultSettingsOnClick = _b.defaultSettingsOnClick, linkPreviewSettingsStore = _b.linkPreviewSettingsStore, mobileLayout = _b.mobileLayout;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("section", { className: "".concat(BASE_CLASS_NAME, "__image space-stack-m") },
                react_1.default.createElement(LinkPreviewCard_1.LinkPreviewCard, { clickable: false, imageUrl: linkPreviewSettingsStore.previewImageUrl })),
            !this.allImageUrls && react_1.default.createElement(kaleidoscope_1.Spinner, null),
            react_1.default.createElement("section", { className: "".concat(BASE_CLASS_NAME, "__image-buttons-container") }, (_a = this.allImageUrls) === null || _a === void 0 ? void 0 : _a.map(function (item) { return (react_1.default.createElement(LinkPreviewImageButton_1.LinkPreviewImageButton, { key: item, imageUrl: item, handleLinkPreviewImageChange: _this.handleLinkPreviewImageChange, currentImage: linkPreviewSettingsStore.previewImageUrl })); })),
            !mobileLayout && (react_1.default.createElement("section", null,
                react_1.default.createElement(kaleidoscope_1.Button, { width: "full", onClick: this.openLibraryClick }, "Open image library"),
                this.isAdminUser && (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__link-container") }, this.hasAccessToDefaultsOverride ? (react_1.default.createElement(kaleidoscope_1.Link, { href: "/#/settings/link-preview", onClick: function () {
                        if (!!defaultSettingsOnClick) {
                            defaultSettingsOnClick();
                        }
                    } }, "Manage default settings")) : this.planRequiredForDefaultsOverride ? (react_1.default.createElement("p", { className: "".concat(BASE_CLASS_NAME, "__link-container--upsell") },
                    "Upgrade to the ",
                    react_1.default.createElement(kaleidoscope_1.Link, { onClick: function () {
                            _this.initSubscription.init();
                        } }, "".concat(this.planRequiredForDefaultsOverride, " plan")),
                    " to manage your default preview settings.")) : (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__link-container--ghost") },
                    react_1.default.createElement(kaleidoscope_2.GhostBlock, null),
                    react_1.default.createElement(kaleidoscope_2.GhostBlock, { className: "".concat(BASE_CLASS_NAME, "__link-container--ghost-lower") })))))))));
    };
    var _a, _b;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], LinkPreviewSettings.prototype, "allImageUrls", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], LinkPreviewSettings.prototype, "planRequiredForDefaultsOverride", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("assetLibraryOverlay"),
        __metadata("design:type", typeof (_a = typeof AssetLibraryOverlay_1.AssetLibraryOverlay !== "undefined" && AssetLibraryOverlay_1.AssetLibraryOverlay) === "function" ? _a : Object)
    ], LinkPreviewSettings.prototype, "assetLibraryOverlay", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("initSubscription"),
        __metadata("design:type", Object)
    ], LinkPreviewSettings.prototype, "initSubscription", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("rolesService"),
        __metadata("design:type", Object)
    ], LinkPreviewSettings.prototype, "rolesService", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("upsellerService"),
        __metadata("design:type", typeof (_b = typeof UpsellerService_1.default !== "undefined" && UpsellerService_1.default) === "function" ? _b : Object)
    ], LinkPreviewSettings.prototype, "upsellerService", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("user"),
        __metadata("design:type", Object)
    ], LinkPreviewSettings.prototype, "user", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("apiBaseUrl"),
        __metadata("design:type", String)
    ], LinkPreviewSettings.prototype, "apiBaseUrl", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkPreviewSettings.prototype, "handleLinkPreviewImageChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkPreviewSettings.prototype, "openLibraryClick", void 0);
    LinkPreviewSettings = __decorate([
        mobx_react_1.observer
    ], LinkPreviewSettings);
    return LinkPreviewSettings;
}(react_1.default.Component));
exports.LinkPreviewSettings = LinkPreviewSettings;
